import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Services.css";
import image from "../assests/services_image_4.jpg"
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsLetter";
import HeroSection from "./HeroSection";

function Services2() {
  useEffect(() => {
      AOS.init({
        duration: 1000,
        once: true,
      });
      window.scrollTo(0, 0);
    }, []);

    const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const imageRef = useRef(null);

  useEffect(() => {
    if (imageRef.current) {
      const height = imageRef.current.clientHeight;
      setContentHeight(height);
    }
  }, []);

  const features = [
    "Innovative ARM® + FPGA architecture for differentiation, analytics & control",
    "Extensive OS, middleware, stacks, accelerators, and IP ecosystem",
    "Multiple levels of hardware and software security",
    "Integration delivering the de facto programmable platform",
    "System level performance through optimized architecture",
    "Most flexible & scalable platform for maximum reuse and best TTM"
  ];

  // Split features array into two equal parts
  const midpoint = Math.ceil(features.length / 2);
  const leftColumnFeatures = features.slice(0, midpoint);
  const rightColumnFeatures = features.slice(midpoint);


  useEffect(() => {
    if (imageRef.current) {
      const height = imageRef.current.clientHeight;
      setContentHeight(height);
    }
  }, []);

  return (
    <div className="app">
      <Header />
      <Navbar />
      

      {/* Hero Section */}
      {/* <div className="bg-customBlue text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
          <h1 className="font-nova-square text-4xl font-thin text-black">
          Software-Defined Radios for CubeSat Applications
          </h1>
          <p className="text-black">
          <Link to={"/"}> Home </Link>{' > '} <Link to={"/products"}>Products </Link> {'>'} <Link to={"/products/products2"}>Software-Defined Radios for CubeSat Applications </Link>
          </p>
        </div>
      </div>
      </div> */}

      <HeroSection 
        title="Software-Defined Radios for CubeSat Applications" 
        breadcrumb={
          <>
            <Link to={"/products"}>Products</Link> {' > '} 
            <Link to={"/products/products2"}>Software-Defined Radios for CubeSat Applications</Link>
          </>
        } 
      />

      <div className="max-w-6xl mx-auto p-6 mt-4">
        {/* Image Section */}
        {/* <div data-aos="zoom-in" className="mt-8">
          <div className="relative group overflow-hidden rounded-xl shadow-2xl">
            <img
              src={image}
              alt="Mission Control Software"
              className="w-full h-[400px] object-cover transform transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
        </div> */}
        <div className="flex flex-col md:flex-row items-center gap-8 max-w-6xl mx-auto">
      <div data-aos="zoom-in" className="md:w-1/2">
        <div className="relative group overflow-hidden rounded-xl shadow-2xl">
          <img
            src={image}
            alt="Mission Control Software"
            className="w-full h-[350px] object-cover transform transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>
      {/* Introduction */}
      <div data-aos="fade-up" className="prose max-w-none md:w-1/2 space-y-5">
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
        Sensing and Communication Applications using powerful and advanced FPGA Technology CubeSats have revolutionized the way scientific community perceive space. The majority of CubeSat communication is greatly limited by the AX.25 standards, the small communication window, the available transmission power, and the available bandwidth at VHF/UHF band.
        </p>
        <hr className="border-gray-300 my-4" />
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
        The iBLINK SDR platform is utilized for a high-speed S- or K band in a highly miniaturized radio system for long distance communication and inter-satellite links. The FPGA module can be used for other advanced processing requirements such as image processing etc. utilizing the high capacity of the system. 
        {/* The built-in software is available for in-orbit programming or applying scripting tools limiting size of program uploads.            */}
        </p>
      </div>
    </div>

        {/* Content Sections */}
        <div className="mt-12 space-y-8">
          {/* Introduction */}
          {/* CALISTO Overview */}
          <div data-aos="fade-up" className="bg-gray-200 rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            
            <p className="text-lg text-gray-700 text-justify">
            The iBLINK SDR for CubeSat will address all the above limitations. The radio operates at S-band, employs quadrature amplitude modulation with a maximum data rate of 60 Mb/s consuming 2.6 Watts in transmit mode and 0.4 Watts in receive mode. The digital signal processing functions and the mode control of the radio are orchestrated by a field programmable gate array system-on-chip. The analog radio frequency domain is accommodated by a 4-layer printed circuit board with dimensions of 92 mm × 88 mm. The SDR is an adaptive, on-flight reconfigurable communication platform that will revolutionize the current communication capabilities of the CubeSats and expand nanosatellites mission perspectives.
            </p>
            
          </div>


          {/* Capabilities List */}
          {/* <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg">
            <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-6">Technical Capabilities</h2>
            <div className="grid md:grid-cols-2 gap-2">
              {[
                "Innovative ARM® + FPGA architecture for differentiation, analytics & control",
                "Extensive OS, middleware, stacks, accelerators, and IP ecosystem",
                "Multiple levels of hardware and software security",
                "Integration delivering the de facto programmable platform",
                "System level performance through optimized architecture",
                "Most flexible & scalable platform for maximum reuse and best TTM",
                
              ].map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center space-x-4 p-3 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                >
                  <div className="h-2 w-2 rounded-full bg-blue-500" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div> */}

          <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg">
      <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-6">
        Technical Capabilities
      </h2>
      <div className="grid md:grid-cols-2 gap-8">
        <style>
          {`
            .feature-list {
              list-style: none;
              padding-left: 0;
              border-left: 3px solid #3B82F6;
              margin-left: 10px;
              padding-left: 20px;
            }
            
            .feature-list li {
              padding: 12px 0;
              position: relative;
              margin-bottom: 15px;
              color: #374151;
              transition: transform 0.3s ease;
            }
            
            .feature-list li:hover {
              transform: translateX(10px);
            }
            
            .feature-list li::before {
              content: "→";
              position: absolute;
              left: -30px;
              top: 50%;
              transform: translateY(-50%);
              color: #3B82F6;
              font-weight: bold;
              opacity: 0;
              transition: opacity 0.3s ease;
            }
            
            .feature-list li:hover::before {
              opacity: 1;
            }
          `}
        </style>
        
        {/* Left Column */}
        <ul className="feature-list">
          {leftColumnFeatures.map((feature, index) => (
            <li
              key={index}
              className="text-gray-700"
            >
              {feature}
            </li>
          ))}
        </ul>

        {/* Right Column */}
        <ul className="feature-list">
          {rightColumnFeatures.map((feature, index) => (
            <li
              key={index + midpoint}
              className="text-gray-700"
            >
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
    
        </div>
      </div>

      <NewsletterSection />
      <Footer />
    </div>
  );
}

export default Services2;